<template>
  <div class="summary-container">
    <div class="summary">
      <h2>Payment Summary</h2>
      <!-- <div class="tenure-section">
        <h4>Set Tenure</h4>
        <div class="tenure-bar">
          <div class="point">
            <p>0</p>
          </div>
          <div class="point" v-for="item of tenureItems" :key="item.point" @click="setActivePoints(item.point)">
            <p
              :class="item.marked ? 'marked' : ''"
            >
              {{ item.marked ? item.point + " months" : item.point }}
            </p>
            <div v-show="item.marked && item.active" :class="item.marked ? 'marked' : ''"></div>
            <div v-show="!item.marked" :class="item.active ? 'active' : ''"></div>
          </div>
        </div>
        <div class="base-line">
          <div class="blue-line" :style="{width: `${getProgressPercent}%`}"></div>
        </div>
      </div> -->
      <div class="quantity">
        <label for="quantity">Quantity of Inverter: </label>
        <input
          type="number"
          name="quantity"
          id="quantity"
          min="1"
          max="500"
          width="25%"
          v-model="quantity"
        />
      </div>
      <div class="summary-table">
        <div>
          <p>Total 1st Month Payment (payable now)</p>
          <p>
            NGN
            {{
              Intl.NumberFormat("en-US").format(activePackage.firstPaymentAmt)
            }}
          </p>
        </div>
        <div class="tabbed">
          <p>2 Months Upfront Payment</p>
          <p>
            NGN
            {{
              Intl.NumberFormat("en-US").format(
                2 * +activePackage.monthlyPaymentValue
              )
            }}
          </p>
        </div>
        <div class="tabbed">
          <p>Caution fee (Refundable)</p>
          <p>
            NGN
            {{ Intl.NumberFormat("en-US").format(activePackage.cautionFee) }}
          </p>
        </div>
        <div class="tabbed">
          <p>Subsequent Monthly Payment</p>
          <p>
            NGN
            {{
              Intl.NumberFormat("en-US").format(
                activePackage.monthlyPaymentValue
              )
            }}
          </p>
          <img
            :src="require('../../../../assets/img/multi-arrow.svg')"
            class="arrows"
          />
        </div>
        <!-- <div class="bold-text">
          <p>Subsequent Monthly Payments</p>
          <p>
            NGN {{ Intl.NumberFormat("en-US").format(monthlyPaymentValue) }}
          </p>
        </div> -->
      </div>
    </div>
    <div class="illustration">
      <div class="description">
        System ownership is transferred upon meeting all lease obligations
      </div>
      <img
        :src="require('../../../../assets/img/polygon.svg')"
        class="polygon"
        alt="Comment Bubble"
      />
      <img :src="require('../../../../assets/img/female-wave.gif')" alt="" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "LOSummary",
  props: ["updateStatus", "updateTracker", "getCustomerProductDetails"],
  computed: {
    ...mapGetters(["getUserSession"]),
    getProgressPercent() {
      let percent;
      this.tenureItems.map(item => {
        if (item.point == this.activeTenure) percent = item.percent;
      });
      return percent;
    }
  },
  watch: {
    quantity(newValues, oldValues) {
      if (!newValues) return;
      this.activePackage = {
        firstPaymentAmt: 299700 * newValues,
        cautionFee: 99900 * newValues,
        monthlyPaymentValue: 99900 * newValues
      };
      this.setActivePoints(this.activeTenure);
    }
  },
  data() {
    return {
      activeTenure: 6,
      quantity: 1,
      tenureItems: [
        {
          point: 6,
          percent: 17.5
        },
        {
          point: 12,
          percent: 33.5
        },
        {
          point: 18,
          percent: 50
        },
        {
          point: 24,
          percent: 66
        },
        {
          point: 30,
          percent: 82.5
        },
        {
          point: 36,
          percent: 100,
          active: true
        }
      ],
      typeProduct: 0,
      productName: "",
      monthlyPaymentValue: "",
      activePackage: {
        firstPaymentAmt: 299700,
        cautionFee: 99900,
        monthlyPaymentValue: 99900
      },
      setActivePoints(point) {
        let activeStatus = true;
        this.unmarkPoints();
        this.tenureItems.map(item => {
          item.active = activeStatus;
          if (item.point == point) {
            this.activeTenure = point;
            item.marked = true;
            activeStatus = false;
          }
        });

        this.$store.state.onboardingCustomerState.tenure = this.activeTenure;
        this.PMT(0.015, this.activeTenure, this.typeProduct, 0, 0);

        this.getCustomerProductDetails({
          customerid: this.getUserSession.id,
          productid: this.productPackage.id,
          tenure: this.activeTenure,
          firstpaymentamt: this.activePackage.firstPaymentAmt,
          recurrentmonthlyamt: parseFloat(this.monthlyPaymentValue),
          monthlyincomerange: "",
          employmentstatus: "",
          totalpayment:
            this.activeTenure * this.monthlyPaymentValue +
            0.05 * this.typeProduct,
          cautionfee: parseFloat(this.monthlyPaymentValue),
          setupfee: "0",
          typeofbusiness: "Micheal, please remove this and upfrontPayment",
          upfrontpayment: 0
        });

        console.log("Please find meeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee", this.getCustomerProductDetails)
      }
    };
  },
  methods: {
    unmarkPoints() {
      this.tenureItems.map(item => delete item.marked);
    },
    PMT(rate = 0.015, nperiod, pv, fv = 0, type = 0) {
      if (rate == 0) return -(pv + fv) / nperiod;

      var pvif = Math.pow(1 + rate, nperiod);
      var pmt = (rate / (pvif - 1)) * -((pv - 0.05 * pv) * pvif + fv);

      if (type == 1) {
        pmt /= 1 + rate;
      }
      this.monthlyPaymentValue =
        Math.abs(pmt) === "Infinity" ? 0.0 : Math.abs(pmt).toFixed(2);
    },
    getProductPackage() {
      this.productPackage = this.$store.state.onboardingPackageType;
      this.typeProduct = this.productPackage.amountOS;
      this.productName = this.productPackage.name;
    }
  },
  mounted() {
    console.log("rfsf", this.$store.state.onboardingCustomerState);
    this.updateTracker(true);
    this.updateStatus(1);
    this.PMT(0.015, this.activeTenure, this.typeProduct, 0, 0);
  },
  beforeMount() {
    this.getProductPackage();
    this.setActivePoints(this.activeTenure);
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../assets/scss/_reduced_variables.scss";

h1,
h2,
h3,
h4,
p {
  margin: 0;
  padding: 0;
  font-family: "DM Sans", sans-serif;
  font-weight: 400;
}

.quantity label {
  font-weight: normal;
}
.quantity input {
  width: 50px;
  border-radius: 6px;
  height: 30px;
  border: 1px solid #411900;
}

p {
  color: #727272;
  font-size: 16px;
  line-height: 24px;
}

h2 {
  color: #0892d0;
  margin-bottom: 18px;
}

.summary-container {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.summary {
  width: 55%;

  h2 {
    color: #0892d0;
    margin-bottom: 30px;
    font-weight: 700;
  }

  > div {
    width: 100%;
  }

  .summary-table {
    padding: 0px 28px;
    background: #fafafa;

    > div {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      padding: 17px 0px;
      border-bottom: 1px dashed #e8e2e2;

      p {
        color: #000000;
        font-size: 16px;
      }

      p:last-child {
        text-align: right;
        width: 30%;
      }

      &:last-child {
        border-bottom: none;
      }
    }

    .bold-text p {
      font-weight: bold;
    }

    .tabbed {
      position: relative;
    }

    .tabbed p {
      margin-left: 55px;
    }

    .tabbed .arrows {
      position: absolute;
      bottom: 30px;
      left: 25px;
    }
  }

  .tenure-section {
    margin-bottom: 30px;

    h4 {
      color: #fe7a11;
      margin-bottom: 10px;
      font-weight: bold;
    }

    .tenure-bar {
      display: flex;
      justify-content: space-between;

      .point {
        text-align: center;
        position: relative;
        width: 15px;
        overflow-x: visible;
        cursor: pointer;

        &:first-child {
          cursor: text;
        }

        &:last-child {
          text-align: right;
        }

        p {
          color: #efefef;
          font-size: 12px;
          line-height: 16px;
          margin-bottom: 2px;
          height: 20px;
        }

        div {
          width: 3px;
          height: 8px;
          border-radius: 2px;
          background: #efefef;
          display: inline-block;
        }

        div.active {
          background: #ace5ff;
        }

        p.marked {
          padding: 2px 8px;
          border-radius: 5px;
          background: #0892d0;
          width: 80px;
          margin-left: -32.5px;
        }

        div.marked {
          width: 12px;
          height: 12px;
          border-radius: 50%;
          background: #0892d0;
        }
      }
    }

    .base-line {
      background: #efefef;
      height: 5px;
      border-radius: 9px;
      margin-top: -14px;

      .blue-line {
        width: 82.5%;
        height: 5px;
        background: #ace5ff;
        border-radius: 9px;
      }
    }
  }
}

.illustration {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  max-width: 350px;

  img:first-child {
    margin-bottom: -3rem;
    z-index: 3;
  }
}

.description {
  max-width: 340px;
  border-radius: 40px;
  padding: 32px 20px;
  background: #e6f6ff;
  text-align: center;
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  color: #0892d0;
}

.polygon {
  width: 5.3rem;
  height: 5.8rem;
  margin-left: 21rem;
  margin-top: -1.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/onboarding/leaseToOwn/LOSummary.vue